import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { redirectToCheckout } from "@/lib/stripe";
import { toast } from "sonner";

interface UpgradeButtonProps {
  variant?: "default" | "outline" | "secondary";
  className?: string;
}

export default function UpgradeButton({ variant = "default", className }: UpgradeButtonProps) {
  const { user } = useAuth();

  const handleUpgrade = async () => {
    try {
      if (!user) {
        toast.error("Please sign in to upgrade");
        return;
      }

      if (!user.email) {
        toast.error("No email associated with account");
        return;
      }

      await redirectToCheckout(user.id, user.email);
    } catch (error) {
      console.error('Error during checkout:', error);
      toast.error("Failed to start checkout process. Please try again.");
    }
  };

  return (
    <Button
      variant={variant}
      className={className}
      onClick={handleUpgrade}
    >
      Commit to Consistency
    </Button>
  );
} 